import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { LIFECYCLE, COMPONENT_SYMBOL, ASYNC_ORIGINAL_SYMBOL, ASYNC_RESOLVED_SYMBOL, ASYNC_DEFAULTS_SYMBOL } from './constants';
import { createProps } from './create-props';
let counter = 0;
export default class Component {
  constructor(...propObjects) {
    _defineProperty(this, "id", void 0);

    _defineProperty(this, "props", void 0);

    _defineProperty(this, "count", void 0);

    _defineProperty(this, "lifecycle", void 0);

    _defineProperty(this, "parent", void 0);

    _defineProperty(this, "context", void 0);

    _defineProperty(this, "state", void 0);

    _defineProperty(this, "internalState", void 0);

    this.props = createProps(this, propObjects);
    this.id = this.props.id;
    this.count = counter++;
    this.lifecycle = LIFECYCLE.NO_STATE;
    this.parent = null;
    this.context = null;
    this.state = null;
    this.internalState = null;
    Object.seal(this);
  }

  get root() {
    let component = this;

    while (component.parent) {
      component = component.parent;
    }

    return component;
  }

  clone(newProps) {
    const {
      props
    } = this;
    const asyncProps = {};

    for (const key in props[ASYNC_DEFAULTS_SYMBOL]) {
      if (key in props[ASYNC_RESOLVED_SYMBOL]) {
        asyncProps[key] = props[ASYNC_RESOLVED_SYMBOL][key];
      } else if (key in props[ASYNC_ORIGINAL_SYMBOL]) {
        asyncProps[key] = props[ASYNC_ORIGINAL_SYMBOL][key];
      }
    }

    return new this.constructor({ ...props,
      ...asyncProps,
      ...newProps
    });
  }

}

_defineProperty(Component, "componentName", 'Component');

_defineProperty(Component, "defaultProps", {});
//# sourceMappingURL=component.js.map